import{jsx as t,jsxs as x}from"react/jsx-runtime";import{useEffect as $}from"react";import a,{css as o}from"styled-components";import{CSSTransition as y}from"react-transition-group";import{resolveColorWithNeutral as v,resetButtonStyle as b}from"../../utils/utils.js";import k from"../../icons/components/AlertIcon.js";import E from"../../icons/components/CheckCircleIcon.js";import B from"../../icons/components/CloseIcon.js";import C from"../../icons/components/InfoIcon.js";const S={top:o`
    top: 0;
  `,bottom:o`
    bottom: 0;
  `},z={right:o`
    right: 0;
  `,center:o`
    left: 50%;
    transform: translate(-50%, 0);
  `,left:o`
    left: 0;
  `},c=200,r="anim",N=a.div`
  font-family: ${({theme:e})=>e.typography.fontBaseFamily};
  position: fixed;
  display: flex;
  align-items: center;

  line-height: 1rem;
  margin: 1rem;

  max-width: 630px;

  border-radius: 0.4rem;
  padding: 1.15rem 1.25rem;

  font-weight: ${({theme:e})=>e.typography.fontBaseBoldWeight};
  font-size: 0.875rem;

  box-shadow: ${({theme:e})=>e.elevations.elevation8};
  background-color: ${({theme:e,$color:i})=>i!=="none"?v(e,i).lighter:e.colors.background.light};

  color: ${({theme:e})=>e.colors.text.dark};

  ${e=>S[e.origin.vertical||"bottom"]}
  ${e=>z[e.origin.horizontal||"left"]}

  transition: opacity ${c}ms ease-in;

  &.${r}-enter {
    opacity: 0;
  }
  &.${r}-enter-active {
    opacity: 1;
  }
  &.${r}-exit {
    opacity: 1;
  }
  &.${r}-exit-active {
    opacity: 0;
  }
`,O=a.div`
  display: inline-flex;
  margin: -0.25rem 0;
  margin-right: 0.75rem;

  ${e=>e.type==="text"&&"margin-right: 0;"}

  svg {
    font-size: 1.5rem;
    color: ${({theme:e})=>e.colors.text.dark};
  }
`,w=a.button`
  ${b}
  display: flex;
  cursor: pointer;

  /* Bigger click area */
  padding: 0.25rem;

  /* Negate padding */
  margin: -0.25rem;
  margin-left: 0.5rem;

  svg {
    font-size: 1.5rem;
  }

  &:focus-visible {
    outline: revert;
  }
`,T=a.span`
  flex: 1;
`,W={error:t(k,{}),success:t(E,{}),info:t(C,{}),text:""},p=({message:e,color:i="none",type:n="info",action:l,isOpen:f,origin:g={},onClose:m=()=>{},onExited:d=()=>{},autoHideDuration:s=4e3,...h})=>($(()=>{const u=setTimeout(m,s);return()=>clearTimeout(u)},[s,m]),t(y,{in:f,timeout:c,mountOnEnter:!0,unmountOnExit:!0,onExited:d,classNames:r,children:x(N,{...h,$color:i,origin:g,role:n==="error"?"alert":void 0,"aria-live":n==="error"?"assertive":"polite",children:[t(O,{type:n,children:W[n]}),t(T,{children:e}),l&&l,t(w,{onClick:m,"aria-label":"Close",type:"button",children:t(B,{})})]})}));export{p as Snackbar,p as default};
